module.exports = __webpack_public_path__ + "static/media/bevl-03.ca237e97.jpg";